import React, { useState } from 'react'
import { MobileFilterContext } from '../../components'

const MobileFilter = ({ children }) => {
  const [active, setActive] = useState('')
  const setActivePanel = (key) => {
    setActive(key)
  }

  return (
    <MobileFilterContext.Provider value={{ active, setActivePanel }}>
      <div>
        { children }
      </div>
    </MobileFilterContext.Provider>
  )
}

export { MobileFilter }
